import { QueryClient, type VueQueryPluginOptions } from '@tanstack/vue-query'

import { ApiError } from './errors'

/**
 * Server state ide výhradne cez TanStack Query (KONVENCIE.md, Frontend).
 *
 * Predvoľby vychádzajú z toho, ako sa nástroj používa: obchodník má otvorenú
 * jednu ponuku dlho, prepína medzi taby a nechce, aby sa mu tabuľka pod rukami
 * prekreslila. Preto žiadny refetch pri fokuse okna a krátky, ale nenulový
 * `staleTime`.
 */
export function createQueryClient(): QueryClient {
	return new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 30_000,
				gcTime: 5 * 60_000,
				refetchOnWindowFocus: false,
				retry: (failureCount, error) => {
					// 4xx sa neopakuje — druhý pokus skončí rovnako a len predĺži čakanie.
					if (error instanceof ApiError && error.isPermanent()) {
						return false
					}

					return failureCount < 2
				},
			},
			mutations: {
				// Mutácia mení dáta; opakovať ju automaticky je nebezpečné
				// (dvakrát odoslaná objednávka).
				retry: false,
			},
		},
	})
}

export const vueQueryPluginOptions: VueQueryPluginOptions = {
	queryClient: createQueryClient(),
}
